import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "D:\\Project\\heshan\\code\\heshan_web\\node_modules\\core-js\\modules\\es6.array.iterator.js";
import "D:\\Project\\heshan\\code\\heshan_web\\node_modules\\core-js\\modules\\es6.promise.js";
import "D:\\Project\\heshan\\code\\heshan_web\\node_modules\\core-js\\modules\\es6.object.assign.js";
import "D:\\Project\\heshan\\code\\heshan_web\\node_modules\\core-js\\modules\\es7.promise.finally.js";

/*
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2020-12-21 09:49:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-12 17:49:04
 * @FilePath: \heshan_web\src\main.js
 */
import Vue from 'vue';
import axios from "./router/axios";
import VueAxios from 'vue-axios';
import App from "./App";
import router from "./router/router";
import "./permission"; // 权限

import "./error"; // 日志

import "./cache"; //页面缓存

import store from "./store";
import { loadStyle } from "./util/util";
import global from "./util/global";
import * as urls from '@/config/env';
import Element from 'element-ui';
import { iconfontUrl, iconfontVersion } from '@/config/env';
import _i18n from "./lang"; // Internationalization

import "./styles/common.scss"; //导入主题文件
// import '@/theme/index.js'

import basicBlock from "./components/basic-block/main";
import basicContainer from "./components/basic-container/main";
import thirdRegister from "./components/third-register/main";
import avueUeditor from 'avue-plugin-ueditor';
import website from '@/config/website';
import "./assets/css/common.scss";
Vue.use(router);
Vue.use(VueAxios, axios);
Vue.use(Element, {
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
});
Vue.use(window.AVUE, {
  size: 'small',
  tableSize: 'small',
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
});
import { url } from '@/config';
window.socketName = ''; //注册全局容器

Vue.component('basicContainer', basicContainer);
Vue.component('basicBlock', basicBlock);
Vue.component('thirdRegister', thirdRegister);
Vue.component('avueUeditor', avueUeditor); // 加载相关url地址

Object.keys(urls).forEach(function (key) {
  Vue.prototype[key] = urls[key];
});
Vue.prototype.$global = global; // 加载website

Vue.prototype.website = website; // 动态加载阿里云字体库

iconfontVersion.forEach(function (ele) {
  loadStyle(iconfontUrl.replace('$key', ele));
});

if (process.env.NODE_ENV == 'development') {
  Vue.config.devtools = true;
} else {
  Vue.config.devtools = false;
}

Vue.config.productionTip = false;
Vue.prototype.url = url;
var vueThis = new Vue({
  router: router,
  store: store,
  i18n: _i18n,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');
export default vueThis;